import React, { useState, useEffect } from "react";
import { useHistory } from "react-router";

import { ReactComponent as BackIcon } from "assets/img/svg/BackButton.svg";

import IconButtonWrapper from "../../common/form-fields-mui/IconButtonWrapper";
import APopover from "../../common/a-popover";
import AButton from "../../common/form-fields-mui/AButton";
import FilterPhaseRows from "./FilterPhaseRows";
import AInput from "../../common/formFeilds/customInput/AInput";

import { phaseDropdown } from "./constants";

const TableHeader = ({ listRef, filters, crctDropdown, applyFilter }) => {
  const history = useHistory();
  const [searchByPhase, setSearchByPhase] = useState("");
  const [filterForm, setFilterForm] = useState(filters);
  const [filterCount, setFilterCount] = useState(0);

  useEffect(() => {
    if (typeof filters.phaseName === "string") {
      const filterPhaseOption = phaseDropdown.filter(
        (item) => item.value.toLowerCase() === filters.phaseName.toLowerCase()
      );
      setFilterForm({ ...filters, phaseName: filterPhaseOption });
    } else setFilterForm(filters);
  }, [filters]);

  const filterFormHandler = (value, key) =>
    setFilterForm((prev) => ({ ...prev, [key]: value }));

  const onKeyDown = (e) => {
    if (e.key === "Enter" || e.keyCode === 13) {
      applyFilter({ ...filterForm, phaseName: searchByPhase });
    }
  };

  return (
    <div className="d-flex justify-content-between">
      <div className="d-flex align-items-center">
        <IconButtonWrapper onClick={() => history.goBack()}>
          <BackIcon />
        </IconButtonWrapper>
        <div className="ml-3 text-bold color-dark flex-grow-1">
          Phase configuration
        </div>
      </div>

      <div className="d-flex align-items-center">
        <AInput
          placeholder={`Search by Phase`}
          style={{ minWidth: "250px" }}
          rightSearchIcon
          crossIcon
          value={searchByPhase}
          handler={(value) => {
            setSearchByPhase(value);
          }}
          onKeyDown={(e) => onKeyDown(e)}
          crossHandler={() => {
            setSearchByPhase("");
            applyFilter({ ...filterForm, phaseName: "" });
          }}
          searchIconClickHandler={() =>
            applyFilter({ ...filterForm, phaseName: searchByPhase })
          }
        />

        <APopover
          buttonComponent={(onClick, styles) => (
            <AButton
              className="tiny-semi-bold color-dark"
              onClick={onClick}
              updatedStyle={{
                minWidth: "61px",
                ...(filterCount > 0
                  ? {
                      border: "1px solid #00B0F5",
                      color: "#00B0F5",
                    }
                  : styles),
              }}
            >
              Filters {filterCount > 0 && <>( {filterCount} )</>}
            </AButton>
          )}
          menuComponent={(closeForm) => (
            <>
              <FilterPhaseRows
                filterCount={filterCount}
                setFilterCount={setFilterCount}
                closeForm={closeForm}
                crctDropdown={crctDropdown}
                applyFilter={applyFilter}
                filterForm={filterForm}
                filterFormHandler={filterFormHandler}
              />
            </>
          )}
          maxHeight={"calc(100vh - 250px)"}
        />
        <AButton
          className="tiny-semi-bold"
          variant="outline"
          size="xs"
          onClick={() => listRef?.current?.addNewRow()}
        >
          Add a new row
        </AButton>
      </div>
    </div>
  );
};

export default TableHeader;
